<template>
  <div class="productPage">
    <ProductBreadCrumbs v-if="!isLoading || (getEnhancedProductData && getEnhancedProductData.DisplayProduct)"/>
    <div class="enhancedProductPage" v-if="getIsEnhancedPDP">
      <EnhancedProductDescription />
    </div>
    <div class="" v-else>
      <ProductDescription />

      <div class="productPage__productData">
        <ProductSpecifications />
        <ProductResources />
        <div
          v-if="!getShowCompatibleProducts"
          class="productPage__productNoCompatibleProductsPadding"
        />
      </div>
    </div>
  </div>
</template>


<script>
import ProductPageMountedService from "../services/ProductPageMountedService";
import ProductDescription from "../components/product/ProductDescription";
import EnhancedProductDescription from "../components/Enhanced/EnhancedProductDescription";
import ProductResources from "../components/product/ProductResources";
import ProductSpecifications from "../components/product/ProductSpecifications";
import ProductAddToCartService from "../services/ProductAddToCartService";
import DOMService from "../services/DOMService";
import { mapGetters } from "vuex";
import { _ } from "vue-underscore";
import ProductBreadCrumbs from "../components/shared/ProductBreadCrumbs";
export default {
  computed: {
    ...mapGetters("enhancedproduct", ["getIsEnhancedPDP", "getEnhancedProductData"]),
    ...mapGetters("product", ["getShowCompatibleProducts", "getBreadCrumbs", "getIsBreadCrumbsLoading","isLoading"])
  },
  data() {
    return {
      dataSourceIds: {
        skuId: null, // Initialize skuId
        seriesId: null // Initialize seriesId
      },
      error: null
    };
  },
  mounted() {
    this.dataSourceIds = this.getDataSourceIds();
    this.loadBreadCrumbs();
    const $domData = document.getElementById("domData");
    const pdpType = $domData ? $domData.dataset.datasourcePdpType : null;
    const variantCode = $domData ? $domData.dataset.variantcode : null;
    const requestReferer = $domData ? $domData.dataset.referer : null;
    const enhancedSeriesId = $domData
      ? $domData.dataset.datasourceEnhancedseriesdataId
      : null;

    const isPageEnhanced = pdpType === "enhanced";
    ProductPageMountedService.productPageMountedLogic(
      this.$store,
      this.dataSourceIds.seriesId,
      this.dataSourceIds.skuId,
      isPageEnhanced,
      variantCode,
      enhancedSeriesId,
      requestReferer
    );

    this.mountedSetScreenSizeMobile();
    this.mountedAddResizeListener();
    this.mountedUpdateEnhancedLocalStorageListener();

    DOMService.mountedBodyClickListener();
  },
  beforeDestroy() {
    this.beforeDestroyRemoveResizeListener();
    this.beforeDestroyUpdateEnhancedLocalStorageListener();
    DOMService.beforeUnmountBodyClickListener();
  },
  methods: {
    addCompatibleProductToCart(e) {
      if (e) {
        const details = {
          source: "triggeredfromcompatibleproduct",
          skuCode: e.detail.productNumber,
          skuId: e.detail.scId,
          productTitle: e.detail.productTitle,
          productImage: e.detail.imageUrl,
          productImageAlt: e.detail.imageAlt,
          productPrice: e.detail.productPrice,
          productMsrp: e.detail.productMsrp,
          currencyCode: e.detail.currencyCode
        };
        ProductAddToCartService.add(
          this.$store,
          this.$modal,
          null,
          "order",
          null,
          details
        );
      }
    },
    addCompatibleProductToQuote(e) {
      if (e) {
        const details = {
          source: "triggeredfromcompatibleproduct",
          skuCode: e.detail.productNumber,
          skuId: e.detail.scId,
          productTitle: e.detail.productTitle,
          productImage: e.detail.imageUrl,
          productImageAlt: e.detail.imageAlt,
          productPrice: e.detail.productPrice,
          productMsrp: e.detail.productMsrp,
          currencyCode: e.detail.currencyCode
        };
        ProductAddToCartService.add(
          this.$store,
          this.$modal,
          null,
          "quote",
          null,
          details
        );
      }
    },
    getDataSourceIds() {
      const $domData = document.getElementById("domData");
      return {
        skuId: $domData ? $domData.dataset.datasourceSkuId : null,
        seriesId: $domData ? $domData.dataset.datasourceSeriesId : null
      };
    },
    getSkuOrSeriesId() {
      return this.dataSourceIds.skuId || this.dataSourceIds.seriesId;
    },
    mountedSetScreenSizeMobile() {
      const isMobile = DOMService.isScreenSizeMobile();
      this.$store.dispatch(
        "enhancedproduct/updateIsScreenSizeMobile",
        isMobile
      );
    },
    loadBreadCrumbs() {
      try {
        const skuId = this.getSkuOrSeriesId(); // Get the SKU ID
        const seriesId = this.dataSourceIds.seriesId || "";
        this.$store.dispatch("product/updateIsBreadCrumbsLoading", true);
        this.$store.dispatch(
        "product/loadBreadCrumbs",
        {skuId,seriesId}
      );
      } catch (error) {
        this.error = "Failed to fetch product data"; // Handle error
      }
    },
    loadAddToCartModalPopup(detail) {
      this.addCompatibleProductToCart(detail);
    },
    loadAddToQuoteModalPopup(detail) {
      this.addCompatibleProductToQuote(detail);
    },
    updateSetScreenSizeMobile() {
      return _.debounce(() => {
        const isMobile = DOMService.isScreenSizeMobile();
        this.$store.dispatch(
          "enhancedproduct/updateIsScreenSizeMobile",
          isMobile
        );
      }, 1000)();
    },
    mountedAddResizeListener() {
      window.addEventListener("resize", this.updateSetScreenSizeMobile);
    },
    beforeDestroyRemoveResizeListener() {
      window.removeEventListener("resize", this.updateSetScreenSizeMobile);
    },
    updateEnhancedLocalStorage() {
      //  const { loginUrl } = event.detail;
      this.$store.dispatch("enhancedproduct/updateEnhancedLocalStorage");
      //  .then(() => {
      //   window.location = loginUrl;
      //  });
    },
    mountedUpdateEnhancedLocalStorageListener() {
      document.body.addEventListener(
        "updateEnhanced-vueLocalstorage",
        this.updateEnhancedLocalStorage
      );
    },
    beforeDestroyUpdateEnhancedLocalStorageListener() {
      document.body.removeEventListener(
        "updateEnhanced-vueLocalstorage",
        this.updateEnhancedLocalStorage
      );
    },
    getProductVariantCharacteritics(itemNumber) {
      const make = "";
      const model = "";
      const item = {};
      item.IsProductVariant = true;
      item.ISPRODUCTVARIANTWITHCHARS = "Y";
      item.VARIANT_CHARACTERISTICS = [
        {
          KEY: "CATALOG_NUMBER",
          VALUE: itemNumber
        },
        {
          KEY: "RSH_MANUFACTURER",
          VALUE: make
        },
        {
          KEY: "RSH_MODEL",
          VALUE: model
        }
      ];
      return item;
    },

    getCookie(cname) {
      var name = cname + "=";
      var decodedCookie = decodeURIComponent(document.cookie);
      var ca = decodedCookie.split(";");
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == " ") {
          c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length);
        }
      }
      return "";
    }
  },
  components: {
    ProductDescription,
    ProductResources,
    ProductSpecifications,
    EnhancedProductDescription,
    ProductBreadCrumbs
  }
};
</script>

<style lang="scss" scoped>
.productPage {
  @include media-breakpoint-up(sm) {
    margin-top: 10px;
  }
  @include media-breakpoint-up(lg) {
    margin-top: 50px;
  }
  &__productNoCompatibleProductsPadding {
    padding-bottom: 35px;
  }
  //&__productData {
  //padding-bottom: 35px;
  //}
  .bold {
    font-weight: bold;
  }
}
</style>

